<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 bill table-contact data-table">
        <thead>
          <tr>
            <th>{{$t("offer.报价单号")}}</th>
            <th>{{$t("offer.客户")}}</th>
            <th>{{$t("offer.SKU / 已报价 / 已设为首选供应商")}}</th>
            <th>{{$t("offer.提交时间")}}</th>
            <th>{{$t("offer.状态")}}</th>
            <th class=" wd-100">{{$t("offer.操作")}}</th>
          </tr>
        </thead>
        <tbody>
        	<template v-for="item in items">
        		<tr :key="item.id">
	            <td class="valign-middle tx-12 pos-relative" :style="{paddingBottom:((item.status == 2 || item.status == 3) && diffTime(item.timeLastUpdate)*(-1)+1>0?'20px':'6px')}">
	              <a class=" tx-info" href="javascript:;">{{item.code}}</a>
	              <p v-if="(item.status == 2 || item.status == 3) && diffTime(item.timeLastUpdate)*(-1)+1>0" class="mg-b-0 pos-absolute tx-ellipsis1 tx-danger">{{$t("offer.还剩")}}<span class="tx-danger">{{diffTime(item.timeLastUpdate)*(-1)+1}}</span>{{$t("offer.天未提交报价将自动作废")}}</p>
	            </td>
	            <td class="valign-middle tx-12"  :style="{paddingBottom:((item.status == 2 || item.status == 3) && diffTime(item.timeLastUpdate)*(-1)+1>0?'20px':'6px')}">
	              <span class=" tx-white">{{item.distributorName}}</span>
	            </td>
	            <td class="valign-middle tx-12" :style="{paddingBottom:((item.status == 2 || item.status == 3) && diffTime(item.timeLastUpdate)*(-1)+1>0?'20px':'6px')}">
	              <span class=" tx-white">{{item.skuCnt}} / {{item.offeredCnt}} / {{item.confirmedCnt}}</span>
	            </td>
              <td class="valign-middle tx-12">
                <span class=" tx-12">{{item.timeSupplierSubmit}}</span>
              </td>
	            <td class="valign-middle tx-12"  :style="{paddingBottom:((item.status == 2 || item.status == 3) && diffTime(item.timeLastUpdate)*(-1)+1>0?'20px':'6px')}">
	              <span v-if="item.status == 9" class=" tx-danger">{{$t("offer.已作废")}}</span>
                <span :class="item.status == 4 ? 'tx-success':'tx-white'">
                  {{$t(showStatus(item.status))}}
                </span>
	            </td>
	            <td class="valign-middle tx-12"  :style="{paddingBottom:((item.status == 2 || item.status == 3) && diffTime(item.timeLastUpdate)*(-1)+1>0?'20px':'6px')}">
	              <a v-if="showAction(item.status)" class=" tx-info" :href="item.url" target="_blank" >{{showAction(item.status)}}</a>
	              <span v-else class=" tx-danger">{{$t("offer.不能报价")}}</span>
	            </td>
	         </tr>
        	</template>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="5">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{$t("offer.没有符合条件的报价单")}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['first_loading', 'items'],
  data(){
    return {
      offerStatus: arrDict.offerStatus,
      offerListStatus: arrDict.offerListStatus,
    }
  },
  methods:{
  	diffTime(time){
  		let receiveTime = moment(time, "YYYY-MM-DD").add(7, 'days');
  		let today = moment();
  		return Number(today.diff(receiveTime, 'days'));
  	},
    showStatus(status){
      return this.offerListStatus[status]
    },
    showAction(status){
      switch(status){
        case '2':
          return this.$t('offer.开始报价')
        break;
        case '3':
          return this.$t('offer.继续报价')
        break;
        case '4':
          return this.$t('offer.查看报价')
        break;
        default:
          return false  
      }
    }
  }
};
</script>

<style scoped>
.data-table tr:nth-child(even) {
  background-color: rgba(0, 0, 0, .2);
}
</style>

